module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00156.76512a62.jpg";